module.exports = __webpack_public_path__ + "img/INF-i-2-I.08ddc0ba.png";